export default "__VITE_ASSET__701b330a__"